import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MainLayout from "../layoutpage/MainLayout";
import api from "../../api/axios";
import Footer from "../../components/Footer";

export default function PropertyBookedList({ user, onLogout }) {
  user = JSON.parse(localStorage.getItem("user"));
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        // Fetch bookings for the current user
        const response = await api.get("/api/bookings?user_only=1");
        if (response.data && response.data.data) {
          console.log("Booked Properties", response.data.data);
          setBookings(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching booked properties:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBookings();
  }, []);

  const getPropertyPrimaryPhoto = (property) => {
    if (
      !property?.photos ||
      !Array.isArray(property.photos) ||
      property.photos.length === 0
    ) {
      return null;
    }
    const photo =
      property.photos.find((p) => p.is_primary) || property.photos[0];
    if (photo.file_path.startsWith("http")) {
      return photo.file_path;
    }
    return `${api.defaults.baseURL}/${photo.file_path}`;
  };

  return (
    <>
      <div className="container">
        <h2 className="text-center fw-bold mb-4">My Booked Properties</h2>

        {loading ? (
          <div className="d-flex justify-content-center my-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : bookings.length > 0 ? (
          <div className="card shadow-sm border-0 rounded-4 p-4">
            <div className="table-responsive">
              <table className="table table-hover align-middle">
                <thead className="table-light">
                  <tr>
                    <th>ID</th>
                    <th>Image</th>
                    <th>Property</th>
                    <th>Unit</th>
                    <th>Status</th>
                    <th className="text-end">Total Price</th>
                    <th className="text-end">Paid</th>
                    <th className="text-end">Due</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {bookings.map((booking) => (
                    <tr key={booking.id}>
                      <td>#{booking.id}</td>
                      <td>
                        {getPropertyPrimaryPhoto(booking.property) ? (
                          <img
                            src={getPropertyPrimaryPhoto(booking.property)}
                            alt={booking.property?.name}
                            style={{
                              height: "50px",
                              width: "70px",
                              objectFit: "cover",
                              borderRadius: "8px",
                            }}
                          />
                        ) : (
                          <div
                            className="bg-light d-flex align-items-center justify-content-center"
                            style={{
                              height: "50px",
                              width: "70px",
                              borderRadius: "8px",
                            }}
                          >
                            <small className="text-muted" style={{ fontSize: "10px" }}>No Image</small>
                          </div>
                        )}
                      </td>
                      <td>
                        <div className="fw-bold">{booking.property?.name}</div>
                        <small className="text-muted">
                          {booking.property?.address}
                        </small>
                      </td>
                      <td>
                        <span className="badge bg-light text-dark border">
                          {booking.unit?.unit_number}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`badge ${booking.status?.status_type === "approved"
                              ? "bg-success"
                              : booking.status?.status_type === "pending"
                                ? "bg-warning text-dark"
                                : "bg-secondary"
                            }`}
                        >
                          {booking.status?.name || booking.status?.status_type}
                        </span>
                      </td>
                      <td className="text-end">
                        ৳ {Number(booking.total_amount).toLocaleString()}
                      </td>
                      <td className="text-end text-success">
                        ৳ {Number(booking.paid_amount).toLocaleString()}
                      </td>
                      <td className="text-end text-danger fw-bold">
                        ৳ {Number(booking.due_amount).toLocaleString()}
                      </td>
                      <td className="text-center">
                        <Link
                          to={`/properties_booked/${booking.id}`}
                          className="btn btn-sm btn-primary px-3 rounded-pill"
                        >
                          View
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="card shadow-sm border-0 rounded-4 p-5 text-center">
                <h5 className="text-muted">No Bookings Found</h5>
                <p className="text-muted mt-3">
                  You haven't booked any properties yet. Explore available
                  properties to make a booking.
                </p>
                <Link
                  to="/properties_available"
                  className="btn btn-outline-primary mt-2"
                >
                  Browse Properties
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
